import React, { useEffect } from 'react'
import { useBanner } from '../../context/BannerContext';
import { WSS_URL } from '../../config/apiConfig';
import { useTaskStatus } from '../../context/TaskStatusContext';
import { useUser } from '../../context/UserContext';
import qs from 'qs'
import iq_api_v2 from '../../services/iqApiV2';

export default function GenerateKSOpportunities({client_name, account_name}) {
    const { user } = useUser();
    const showBanner = useBanner();

    const { registerTask, getTaskData, getConnectionStatus, deregisterTask } =
        useTaskStatus();

    const TASK_ID = `generate_ks_opportunities_${client_name}_${account_name}`;
    const taskData = getTaskData(TASK_ID);
    const isConnected = getConnectionStatus (TASK_ID);

    const handleGenerateKSOpportunities = async(client_name, account_name) => {
        
        try {
            const postData = qs.stringify({"client": client_name, "account": account_name, "user_id": user?.id});
            const response = await iq_api_v2.post(`/generate_mnmks_opportunities`, postData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json', // Matches your curl
                },
            });
            // console.log("response : ", response)
            if(response?.data?.task_id){
                showBanner({
                    message: "Request has been sent!",
                    title: "Alert",
                    type: "success",
                    duration: 10000,
                });

                registerTask(TASK_ID, `${WSS_URL}/${response?.data?.task_id}`);

            }else{
                showBanner({
                    message: "Something went wront. Please try later.",
                    title: "Alert",
                    type: "error",
                    duration: 10000,
                });
            }

        } catch (error) {
            console.error("Error generating ks opportunities:", error);
            showBanner({
                message: "Something went wront. Please try later.",
                title: "Alert",
                type: "error",
                duration: 10000,
            });
        }
    }

    useEffect(() => {
        
        // console.log("taskData", taskData, isConnected);
        if(isConnected && taskData?.status === 'completed'){
            showBanner({
                message: "Account ks opportunities generated successfully ('"+client_name+"' : '"+account_name+"'). Kindly check meta dashboard.",
                title: "Alert",
                type: "success",
                duration: 10000,
            });
            deregisterTask(TASK_ID)
        }

    }, [taskData, isConnected]);

  return (
    <span
        onClick={() => handleGenerateKSOpportunities(client_name, account_name)}
        className="ml-1 btn btn-success btn-sm cursor_p font11"
        title="Generate MnMKS Opportunities"
    >
        <i className={`fa fa-refresh ${taskData?.status === 'pending' ? 'rotating_refresh' : '' }`} ></i> KS Oppo {taskData?.status === 'completed' ? ' - (Generated)' : ''}
    </span> 
  )
}
